import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { LogoDisplayVariant } from '@workee/website-ui-kit';
import { useGetPublicWebsite } from '@/features/website';
import { mq } from '@/features/theme';

const StyledHeader = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '12px',

    [mq.sm]: { padding: '0 16px' },
  };
});

const LogoContainer = styled.div(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

const LogoImage = styled.img(() => {
  return {
    width: '100%',
    height: '100%',
    maxHeight: '24px',
    objectFit: 'contain',
  };
});

const LogoText = styled.div(() => {
  return {
    fontSize: '20px',
    lineHeight: '130%',
    fontWeight: '700',
    textAlign: 'center',
  };
});

interface IHeaderProps {
  className?: string;
  userId: string;
}

export const Header = ({
  className,
  userId,
  children,
}: PropsWithChildren<IHeaderProps>) => {
  const publicWebsiteQuery = useGetPublicWebsite({ userId });

  const renderLogo = () => {
    if (publicWebsiteQuery.data?.configuration) {
      const {
        logoDisplayVariant, logoImage, logoText,
      } = publicWebsiteQuery.data.configuration.layout.header;

      if (logoDisplayVariant === LogoDisplayVariant.IMAGE) {
        return <LogoImage src={logoImage.value} alt="logo" />;
      }

      if (logoDisplayVariant === LogoDisplayVariant.TEXT) {
        return <LogoText>{logoText.value}</LogoText>;
      }
    }

    return null;
  };

  return (
    <StyledHeader className={className}>
      <LogoContainer>
        {renderLogo()}
      </LogoContainer>
      {children}
    </StyledHeader>
  );
};
